export const Translations = {
  'en': {
    'priceLabel': 'Price',
    'psvLabel': 'SV',
    'adrLabel': 'ADR',
    'totalPriceLabel': 'Total',
    'totalPointsLabel': 'Total Points',
    'totalPsvLabel': 'SV',
    'oneTimeLabel': 'One-time',
    'purchaseWithPointsLabel': 'Purchase with points',
    'grandfatheredModalHeader': 'Warning',
    'grandfatheredModalQuestion': 'Grandfathered Price',
    'grandfatheredModalBody': 'By removing this item from your automatic delivery, you will forfeit the grandfathered price and benefits you have been receiving. Would you still like to change this item in your cart?',
    'cancelButtonText': 'Cancel',
    'acceptButtonText': 'Accept',
    'lineItemNewStatusLabel': 'NEW',
    'lastAdrItemMessage': 'To redeem points on your next ADR shipment, you must purchase at least one product. If you would like to place an order using points only, please place a regular web order to redeem these points, not an ADR order.',
    'payWithPointsUnavailableMessage': 'Currently this product is unavailable to be redeemed with points.',
    'pointsBalanceMessage': 'Currently the point balance on your account does not allow for you to redeem your points for this product.',
    'pointsPriceLabel': 'Point Price'
  },
  'es': {
    'priceLabel': 'Precio',
    'psvLabel': 'Volumen Del Producto',
    'adrLabel': 'ADR',
    'totalPriceLabel': 'Total',
    'totalPointsLabel': 'Puntos Totales',
    'totalPsvLabel': 'Volumen Del Producto',
    'oneTimeLabel': 'Una vez',
    'purchaseWithPointsLabel': 'Pagar con puntos',
    'grandfatheredModalHeader': 'Advertencia',
    'grandfatheredModalQuestion': 'Grandfathered Price',
    'grandfatheredModalBody': 'Al eliminar este artículo de su entrega automática, perderá el precio y los beneficios reconocidos que ha estado recibiendo. ¿Aún desea cambiar este artículo en su carrito?',
    'cancelButtonText': 'Cancelar',
    'acceptButtonText': 'Aceptar',
    'lineItemNewStatusLabel': 'NUEVO',
    'lastAdrItemMessage': 'Para canjear puntos en su próximo envío de ADR, debe comprar al menos un producto. Si desea hacer un pedido solo con puntos, coloque un pedido web regular para canjear estos puntos, no un pedido de ADR.',
    'payWithPointsUnavailableMessage': 'Actualmente este producto no está disponible para ser canjeado con puntos.',
    'pointsBalanceMessage': 'Actualmente, el saldo de puntos en su cuenta no le permite canjear sus puntos por este producto.'
  },
  'zh': {
    'priceLabel': '价格',
    'psvLabel': 'PSV点值',
    'adrLabel': 'ADR',
    'totalPriceLabel': '总额',
    'totalPointsLabel': '总积分',
    'totalPsvLabel': 'PSV点值总额',
    'oneTimeLabel': '一次性',
    'purchaseWithPointsLabel': '用积分购买',
    'grandfatheredModalHeader': '警告',
    'grandfatheredModalQuestion': '祖父价格',
    'grandfatheredModalBody': '通过从您的自动送货中删除这件商品，您将丧失您收到的超值价格和优惠。 你还想要在购物车中更换这件物品吗？',
    'cancelButtonText': '取消',
    'acceptButtonText': '接受',
    'lineItemNewStatusLabel': '新',
    'lastAdrItemMessage': '要在下次ADR货件上兑换积分，您必须至少购买一件产品。如果您只想使用积分下订单，请订购常规网上订单以兑换这些积分，而不是ADR订单。',
    'payWithPointsUnavailableMessage': '目前，此产品无法通过积分兑换。',
    'pointsBalanceMessage': '目前，您帐户中的积分余额不允许您兑换此产品的积分。'
  }
};
